<div class="card overflow-hidden rounded-10 shadow">
  <div class="card-body" *ngIf="isLoaded">
    <app-loading-dash [size]="'graph-middle'" />
  </div>
  <div class="card-body" *ngIf="!isLoaded">
    <h6 class="mb-3">{{ 'common.salesThisWeek' | translate}}</h6>
    <div
      echarts
      class="grafico-vendas-semana"
      [options]="echartHorizontalLineChart"
    ></div>
  </div>
</div>
